import React from 'react';
import styles from "./CoinProfile.module.scss";
import Modal from '../Modal/Modal';
import silverCoin from "../../../../assets/icons/asset-icons/silver.svg";
import goldenCoin from "../../../../assets/icons/asset-icons/gold.svg";
import equityCoin from "../../../../assets/icons/asset-icons/equity.svg";
import psCoin from "../../../../assets/icons/asset-icons/profitsharing.svg";
import NoContent from '../../NoContent/NoContent';

const CoinProfile = ({ show, handleClose }) => {
    const coins = [
        {
            icon: silverCoin,
            name: "Silver",
            value: "$10.01",
        },
        {
            icon: goldenCoin,
            name: "Golden",
            value: "$10.01",
        },
        {
            icon: equityCoin,
            name: "Equity",
            value: "$1000.01",
        },
        {
            icon: psCoin,
            name: "Profit Sharing",
            value: "$10.01",
        },
    ];

    return (
        <Modal
            show={show}
            handleClose={handleClose}
            title={"Our Coin profile"}
            className={styles.coin_profile}
        >
            {
                coins.length > 0 ?
                    <ul>
                        {
                            coins.map(item => (
                                <li>
                                    <img src={item.icon} alt="icon" />
                                    <h3>{item.name}</h3>
                                    <h6>{item.value}</h6>
                                </li>
                            ))
                        }
                    </ul>
                    :
                    <NoContent
                        content="It looks like there's no coins to show their profile."
                        className={styles.no_content}
                    />
            }
        </Modal>
    )
}

export default CoinProfile
